export const isValidCertificate = certificate => {
  const certificateRegex =
    /^(?:(?!-{3,}(?:BEGIN|END) CERTIFICATE)[\s\S])*(-{3,}BEGIN CERTIFICATE(?:(?!-{3,}END CERTIFICATE)[\s\S])*?-{3,}END CERTIFICATE-{3,})(?![\s\S]*?-{3,}BEGIN CERTIFICATE[\s\S]+?-{3,}END CERTIFICATE[\s\S]*?$)/;

  if (!certificate) {
    return false;
  }
  if (!certificateRegex.test(certificate)) {
    return false;
  }
  return true;
};
